import React from 'react';
import { useHistory } from 'react-router-dom';
/* Components */
import { Button } from '../Button';

export const RecapButtons = ({ 
  submitEvent,
  returnPage = '/simulatore-commerciale.html'
 }) => {
  const history = useHistory();

  const handleEditSimulationClick = function() {
    history.push(returnPage, { returnButtonClicked: true });
  }

  return (
    <>
      <Button isRecap={true} color="white" hollow={true} text="Modifica simulazione" clickEvent={ handleEditSimulationClick }/>
      <Button isRecap={true} color="white" type="button" text="Prosegui" clickEvent={ submitEvent }/>
    </>
  );
}
